export default "__VITE_ASSET___CI2AEDt__"